import { AxiosInstance } from "axios";
import { ApiService } from "../models/Api.model";
import { IQueryExpensesBasicInfo } from "../interfaces/IQueryExpensesBasicInfo";
import { IExpenseDetail } from "../interfaces/Expense/IExpenseDetail";
import { IExpenseBasicList } from "../interfaces/Expense/IExpenseBasicList";

enum ExpenseSearchServiceEnum {
  getDetailById = "/",
  getBasicInfo = "/basic-info"
}

export class ExpenseSearchService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/expense/search");
  }

  public getDetailById = async (id: number): Promise<IExpenseDetail> => await this.GET(ExpenseSearchServiceEnum.getDetailById + id);
  public getBasicInfo = async (queryString: IQueryExpensesBasicInfo): Promise<IExpenseBasicList> => await this.POST(`${ExpenseSearchServiceEnum.getBasicInfo}`, queryString);
}



// WEBPACK FOOTER //
// ./src/services/api/ExpenseSearch.service.ts